const items = [
  "No welder required",
  "Part 200",
  "14 GA. steel plate",
  "Flush or bypass mount",
  "Square or round tubing",
  "Tek screws included",
  "Patent Pending 19/642,047",
  "Midland, Texas",
];

const Seq = ({ hidden }) => (
  <div className="marquee-seq" aria-hidden={hidden ? "true" : undefined}>
    {items.map((t, i) => (
      <span key={i}>
        {t} <em> · </em>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="marquee" data-testid="marquee">
    <div className="marquee-track">
      <Seq />
      <Seq hidden />
    </div>
  </div>
);
